<template>
  <div class="container pd">
    <div class="bg-container" :style="{ backgroundColor: bgColor }">
      <div class="flex">
        <h3 class="header-font">
          Want to know more?
        </h3>
        <div class="outer">
          <div class="grid">
            <div>
              <a href="mailto:upskill@upskillbangladesh.com" target="_blank">
                <img src="../../assets/chaldal/Icon simple-google.svg" alt="" />
              </a>
              <h2>
                mail
              </h2>
            </div>

            <div>
              <a href="http://m.me/upskillbd" target="_blank">
                <img
                  src="../../assets/chaldal/Icon awesome-facebook-messenger.svg"
                  alt=""
                />
              </a>
              <h2>
                Messenger
              </h2>
            </div>
            <div>
              <a href="https://wa.me/+8801714053213" target="_blank">
                <img
                  src="../../assets/chaldal/Icon ionic-logo-whatsapp.svg"
                  alt=""
                />
              </a>
              <h2>
                WhatsApp
              </h2>
            </div>
            <div>
              <a href="tel:+8801714053213">
                <img
                  src="../../assets/chaldal/call.svg"
                  target="_blank"
                  alt=""
                />
              </a>
              <h2>
                Call
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      required: true,
      default: '#072ac8',
    },
  },
}
</script>

<style scoped>
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: white;
}
.outer {
  min-width: 600px;
  min-height: 100px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 100px;

  margin-bottom: 75px;
}
.grid > :nth-child(n) {
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.grid img {
  margin-top: 35px;
  justify-self: center;
}
.pd {
  padding: 0 25px;
  margin-bottom: 120px;
}
.flex-1 {
  width: 100%;
}
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.flex h1 {
  text-transform: uppercase;
  font-family: 'Open Sans';
  font-size: 60px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffc600;
  padding-top: 50px;
  padding-bottom: 100px;
}
h2 {
  margin-top: 18px;
  text-transform: capitalize;
  font-family: 'Manrope';
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 28px;
  color: white;
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1320px !important;
  }
}
.bg-container {
  border-radius: 4px;
}
@media only screen and (max-width: 600px) {
  .outer {
    min-width: 100%;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5px;

    margin-bottom: 25px;
    padding: 0px;
    place-items: center;
  }
  .grid > :nth-child(n) {
    margin-top: 0px;
    min-height: 100px;
  }
  .pd {
    padding: 0 0px;
    margin-bottom: 0px;
  }
  .flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .flex h3 {
    text-align: center;
    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
    padding-top: 50px;
  }
  .flex h1 {
    text-transform: uppercase;
    font-family: 'Open Sans';
    font-size: 60px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 24px;
    color: #ffc600;
    padding-top: 50px;
    padding-bottom: 100px;
  }
}
</style>
